import * as auth from "@script/auth";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useAuthActions, useIsAuthenticated } from "@hooks/useAuth";
import { useLoginModalActions } from "@hooks/useLoginModal";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import useThrottle from "@/hooks/useThrottle";
import HeaderAlarmSection from "@/layouts/components/HeaderAlarmSection";

function GlobalHeader() {
  const queryClient = useQueryClient();
  const isAuthenticated = useIsAuthenticated();

  const { logout } = useAuthActions();
  const { setOpen } = useLoginModalActions();
  const throttle = useThrottle();

  const navigate = useNavigate();

  // 로그아웃
  const { mutate: logoutMutate } = useMutation({
    mutationFn: async () => await auth.logout(),
    onSuccess: () => {
      logout(); // zustand 상태초기화
      queryClient.clear(); //tanStack 캐시 다삭제
      alert("로그아웃 되었습니다.");
      localStorage.removeItem("selectedGroupId"); // group Id 삭제
      navigate("/"); // Root로
    },
  });

  return (
    <div className="c_pageTop__container">
      <button
        type="button"
        id="j_gnb_triggerMenuToggleBtn"
        className="c_pageHeader__btnUI c_pageHeader__btnUI--verTablet c_icon__sidebar"
      ></button>

      <div
        style={{ display: "flex", alignItems: "center", columnGap: "0.8rem" }}
      >
        <a
          href="https://www.meditong.com/index.asp"
          className="c_familySite--meditong"
        ></a>
      </div>

      <ul className="c_userMenu__container">
        {/* Alram */}
        <HeaderAlarmSection isAuthenticated={isAuthenticated} />

        {isAuthenticated && (
          <li className="fw-600">
            <NavLink to="/support" className="c_userMenu__button">
              고객센터
            </NavLink>
          </li>
        )}

        <li className="fw-600">
          {isAuthenticated ? (
            <button
              type="button"
              className="c_userMenu__button"
              onClick={() => throttle(() => logoutMutate())}
            >
              로그아웃
            </button>
          ) : (
            <button
              type="button"
              className="c_userMenu__button"
              onClick={() => setOpen(true)}
            >
              로그인
            </button>
          )}
        </li>
      </ul>
    </div>
  );
}

export default GlobalHeader;
